module.exports = __webpack_public_path__ + "img/1f30e.74c7e88.svg";